
export default {
    name: "ReplyModal",
    props: {
        replyToVideo: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
            message: "",
            firstName: "",
            lastName: ""
        };
    },

    computed: {
        isReplyReady() {
            return this.message && this.firstName && this.lastName;
        }
    },

    methods: {
        closeModal() {
            this.resetFields();
            // Emit an event to notify the parent component to close the modal
            this.$emit("close");
        },

        sendMessage() {
            this.isLoading = true;

            this.replyToVideo(this.message, this.firstName, this.lastName)
                .catch(() => {
                    this.isLoading = false;
                })
                .then(() => {
                    this.isLoading = false;
                    setTimeout(() => this.closeModal(), 1500);
                });
        },
        resetFields() {
            this.message = "";
            this.isLoading = false;
        }
    }
};
